export default {
  "meta.title": "USFans Spreadsheet Guide: How to Find Products & Shop Smarter",
  "meta.description":
    "Learn how to use the USFans Spreadsheet: browse products by category, compare finds, understand QC, shipping and buying tips, and shop with confidence.",

  "breadcrumb.home": "Home",
  "breadcrumb.current": "Spreadsheet Guide",

  "title": "USFans Spreadsheet Guide: How to Find Products, Compare Finds & Shop Smarter",
  "lead":
    "The USFans Spreadsheet is one of the most useful ways to discover and compare products across many categories. This original guide explains how it works, how to navigate the categories, and what to check before you buy — so you can make better-informed decisions.",

  "toc.title": "Table of Contents",

  "s1.title": "What Is the USFans Spreadsheet?",
  "s1.p1":
    "The USFans Spreadsheet is a shared, organized product catalog. Instead of a single page of random links, it groups items into clear categories such as Shoes, Hoodies, T-Shirts, Jackets, Pants, Headwear, Bags and Accessories. This structure makes it much easier to find a specific type of product and compare what is available.",
  "s1.p2":
    "Many people use the spreadsheet as a starting point for product research. It helps you see at a glance what categories exist, what kinds of products are listed, and where you can go next to learn more about a specific item.",

  "s2.title": "How to Use the Spreadsheet Step by Step",
  "s2.p1":
    "Using the spreadsheet is simple, even if you are new to it. Follow these steps to get the most out of your visit.",
  "s2.li1": "Pick a category that interests you, such as Shoes or Bags.",
  "s2.li2": "Review the products listed under that category.",
  "s2.li3": "Compare the available information, including photos and descriptions.",
  "s2.li4": "Check QC notes and shipping details before deciding.",
  "s2.li5": "Follow the link to the main website to view full details and order.",
  "s2.p2":
    "Because the spreadsheet is organized by category, you save time compared to browsing an unstructured list. You can jump straight to the section that matters to you.",

  "s3.title": "Browse the Main Product Categories",
  "s3.p1":
    "The spreadsheet covers a wide range of product types. Below are the main categories you will typically find, with a short note on what each one includes.",
  "s3.shoes": "Shoes — sneakers, casual and sport footwear.",
  "s3.hoodies": "Hoodies/Sweaters — pullovers and zip-ups.",
  "s3.tshirts": "T-Shirts — short and long sleeve tops.",
  "s3.jackets": "Jackets — outerwear for different seasons.",
  "s3.pants": "Pants/Shorts — jeans, chinos and shorts.",
  "s3.headwear": "Headwear — caps, hats and beanies.",
  "s3.sets": "Sets — matching coordinated outfits.",
  "s3.underwear": "Underwear/Underpants — base layers and briefs.",
  "s3.jersey": "Jersey — sports and team jerseys.",
  "s3.accessories": "Accessories — small add-ons and extras.",
  "s3.bags": "Bags — backpacks, handbags and totes.",
  "s3.belts": "Belts — leather and casual belts.",
  "s3.perfumes": "Perfumes — fragrances for men and women.",
  "s3.other": "Other Stuff — miscellaneous and new arrivals.",
  "s3.p2":
    "You can explore every category directly from the homepage using the dropdown menu or the category cards. Each one opens the matching section on the main website.",

  "s4.title": "What to Check Before You Buy",
  "s4.p1":
    "A good buying decision starts with a quick review of the product information. Here are the key things to check on every listing.",
  "s4.li1": "Product photos — make sure they clearly show the item.",
  "s4.li2": "Description — read the material, size and color details.",
  "s4.li3": "QC information — look for quality-check photos when available.",
  "s4.li4": "Shipping terms — understand the cost and estimated time.",
  "s4.li5": "Payment methods — confirm the available options.",
  "s4.p2":
    "Taking a few seconds to check these details helps you avoid surprises and choose products that match what you expect.",

  "s5.title": "Shipping and Delivery Notes",
  "s5.p1":
    "Shipping costs and delivery times can vary depending on your location and the product. In general, heavier or bulkier items may cost more to ship, and international orders can take longer than domestic ones.",
  "s5.p2":
    "Always review the shipping information shown on the main website before you place an order. If a listing includes a shipping estimate, use it as a guide rather than a guarantee.",

  "table.caption": "Quick Comparison: What to Check on Each Product",
  "table.head1": "Factor",
  "table.head2": "What to Check",
  "table.head3": "Why It Matters",
  "table.r1c1": "Product",
  "table.r1c2": "Photos & description",
  "table.r1c3": "Helps you research the item",
  "table.r2c1": "QC",
  "table.r2c2": "Available quality-check info",
  "table.r2c3": "Shows product quality",
  "table.r3c1": "Shipping",
  "table.r3c2": "Current shipping methods",
  "table.r3c3": "Helps you plan delivery",
  "table.r4c1": "Payment",
  "table.r4c2": "Available payment terms",
  "table.r4c3": "Keeps your order secure",

  "faq.title": "Frequently Asked Questions",
  "faq.q1": "Is the USFans Spreadsheet free to browse?",
  "faq.a1":
    "Yes, browsing the categories and product information through this resource is free. You only pay when you choose to purchase something on the main website.",
  "faq.q2": "Can I buy directly from this site?",
  "faq.a2":
    "No. This site is an informational resource that links you to the main USFans website, where purchases are completed.",
  "faq.q3": "How often is the spreadsheet updated?",
  "faq.a3":
    "The spreadsheet is regularly maintained and updated. For the most current listings, always check the main website.",
  "faq.q4": "How do I find a specific category?",
  "faq.a4":
    "Use the category dropdown or the category cards on the homepage to jump straight to the section you need.",

  "cta.title": "Start Browsing the USFans Spreadsheet",
  "cta.text":
    "Now that you understand how it works, explore the categories and compare finds before you buy.",
  "cta.back": "Back to Homepage",

  "safety.title": "Safety Note",
  "safety.text":
    "This guide provides information only. Always verify product details and shipping terms on the main website before completing any purchase.",
};